import { useId } from 'react';

import Icon from 'ms-ui-primitives/Icon';

import type { Props } from '../types';

const LockOpen = ({
  color,
  size,
  title,
  titleId,
  aphroditeStyles = [],
}: Props) => {
  const mask1Id = useId();
  const mask2Id = useId();
  return (
    <Icon
      color={color}
      size={size}
      aphroditeStyles={aphroditeStyles}
      title={title}
      titleId={titleId}
      viewBoxWidth={20}
      viewBoxHeight={20}
    >
      <mask
        id={mask2Id}
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="3"
        y="0"
        width="14"
        height="19"
      >
        <mask
          id={mask1Id}
          style={{ maskType: 'alpha' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="20"
          height="20"
        >
          <path fill="#D9D9D9" d="M0 0h20v20H0z" />
        </mask>
        <g mask={`url(#${mask1Id})`}>
          <path
            d="M5 18.333c-.458 0-.85-.163-1.177-.49a1.605 1.605 0 0 1-.49-1.177V8.333c0-.458.164-.85.49-1.177.326-.326.719-.49 1.177-.49h7.5V5c0-.695-.243-1.285-.729-1.771a2.41 2.41 0 0 0-1.77-.73c-.584 0-1.095.178-1.532.532a2.598 2.598 0 0 0-.885 1.323.829.829 0 0 1-.344.469.997.997 0 0 1-.573.177.826.826 0 0 1-.594-.23.558.558 0 0 1-.177-.541c.194-.958.674-1.764 1.438-2.417A3.98 3.98 0 0 1 10 .833c1.153 0 2.136.406 2.948 1.219.813.812 1.219 1.795 1.219 2.948v1.666H15c.459 0 .85.164 1.177.49.327.326.49.719.49 1.177v8.333c0 .459-.163.851-.49 1.177-.326.327-.718.49-1.177.49H5Zm0-1.667h10V8.333H5v8.333Zm5-2.5c.459 0 .85-.163 1.177-.49.327-.326.49-.718.49-1.176 0-.459-.163-.851-.49-1.177a1.605 1.605 0 0 0-1.177-.49c-.458 0-.85.163-1.177.49-.326.326-.49.718-.49 1.177 0 .458.164.85.49 1.177.326.326.719.49 1.177.49Z"
            fill="#1C1B1F"
          />
        </g>
      </mask>
      <g mask={`url(#${mask2Id})`}>
        <path d="M0 0h20v20H0z" />
      </g>
    </Icon>
  );
};

LockOpen.displayName = 'LockOpen';

export default LockOpen;
